<!----
    Author: hjlee
    Description:
        가입 폼
---->
<template>
  <xdata-insert-row-control
    v-model="inputVal"
    load-create-url="/auth/public/loadCreateColumns"
    create-url="/auth/public/signUpUser"
    send-authentication-url="/auth/public/sendAuthenticationCode"
    verify-authentication-url="/auth/public/verifyAuthenticationCode"
    purpose="registration"
    :only-required-fields="false"
    :dont-check-author="true"
    :step="step"
    :next-step="nextStep"
    :next-button-name="nextButtonName"
    :save-button-name="saveButtonName"
    :camera-button-image="cameraButtonImage"
    :show-circle="true"
    :show-image-viewer="showImageViewer"
    :cover-image="coverImage"
    :no-toast="true"
    module="user"
    item="user"
    @inserted-data="inserted"
    @next-step="onNextStep"
    @insert-failed="onInsertFailedProcess"
  />
</template>

<script>
export default {
  props: {
    value: {
      type: Object,
      default: undefined
    },
    onInserted: {
      type: String,
      default: ''
    },
    onNext: {
      type: String,
      default: ''
    },
    onInsertFailed: {
      type: String,
      default: ''
    },
    step: {
      type: String,
      default: ''
    },
    nextStep: {
      type: String,
      default: ''
    },
    saveButtonName: {
      type: String,
      default: ''
    },
    nextButtonName: {
      type: String,
      default: ''
    },
    cameraButtonImage: {
      type: String,
      default: undefined
    },
    showImageViewer: {
      type: Boolean,
      default: true
    },
    coverImage: {
      type: Boolean,
      default: true
    }
  },
  data() {
    return {
      inputVal: {}
    }
  },
  watch: {
    value: {
      handler: function(newVal, oldVal) {
        this.inputVal = newVal
      },
      immediate: true,
      deep: true
    },
    inputVal: {
      handler: function(newVal, oldVal) {
        this.$emit('input', newVal)
        this.$emit('input', oldVal)
      },
      deep: true
    }
  },
  methods: {
    inserted(row) {
      if (
        this.onInserted &&
        window.onEvent &&
        window.onEvent[this.onInserted]
      ) {
        window.onEvent[this.onInserted](row)
      }
      let link = '/registration_complete'
      if (
        row &&
        row.createdObject &&
        row.createdObject.partnerBasicRegistered
      ) {
        link += '?partnerBasicRegistered=true'
      }
      this.openLink(link, null, true)
    },
    onNextStep(obj) {
      if (this.onNext && window.onEvent && window.onEvent[this.onNext]) {
        window.onEvent[this.onNext](obj)
      }
    },
    onInsertFailedProcess(obj) {
      if (
        this.onInsertFailed &&
        window.onEvent &&
        window.onEvent[this.onInsertFailed]
      ) {
        window.onEvent[this.onInsertFailed](obj)
      }
    }
  }
}
</script>
